import { bemJoin } from 'bem-join'
import classnames from 'classnames'

export const classNames = classnames
export { bemJoin }
